import { AvatarIdT, SidekickNameT } from "types/avatar"
import { EskTypeT, SponsorT } from "types/sponsor"
import { TConversation, TMessage } from "types/transcript"

import { nowInUTC } from "./time"

// this hook is necessary during some quick transition periods
// when we need a conversation in state, but websocket messages might come in prior to the conversation being loaded from the API
// so we can create a temporary conversation with some default values and receive messages in the meantime
export const getTempConversation = ({
  // eslint-disable-next-line camelcase
  active_esk_sponsor,
  // eslint-disable-next-line camelcase
  active_esk_type,
  // eslint-disable-next-line camelcase
  sidekick_avatar_id,
  // eslint-disable-next-line camelcase
  sidekick_name,
  transcript = [],
}: {
  active_esk_sponsor: SponsorT
  active_esk_type: EskTypeT
  sidekick_avatar_id: AvatarIdT
  sidekick_name: SidekickNameT
  transcript?: TMessage[]
}): TConversation => {
  return {
    // eslint-disable-next-line camelcase
    active_esk_sponsor,
    // eslint-disable-next-line camelcase
    active_esk_type,
    // eslint-disable-next-line camelcase
    sidekick_avatar_id,
    // eslint-disable-next-line camelcase
    sidekick_name,
    debug_mode: false,
    ended_at: "",
    ended_reason: "",
    id: new Date().getTime().toString(),
    started_at: nowInUTC(),
    status: "Started",
    transcript,

    // @ts-ignore
    llm_metadata: [{}], // force unwrap the first element of the array - since it's just a placeholder conversation, the value isn't important
    user_id: "",
    system_prompt: "",
    is_temp: true,
  }
}
